
import {useMutation, useQueryClient} from "@tanstack/react-query";
import React, {useEffect, useState} from "react";

import {toast} from "react-toastify";

import {useFieldArray, useForm} from "react-hook-form";
import {getErrorObj, getValidationMessage, setValidationMessage} from "../../../util/validationMessage";
import Modal from "../../../components/UI/Modal";
import Input from "../../../components/UI/form/Input";
import Button from "../../../components/UI/Button";
import {storeRole, updateRole} from "../../../api/userRoles";
import Checkbox from "../../../components/UI/form/Checkbox";


const RoleForm = ({editRecord = null, permissions, openModal, setOpenModal, setEditUser}) => {
    const [allSelect, setAllSelect] = useState(false)
    const {setValue, getValues, reset, register,control, setError, handleSubmit, watch, formState: { errors }, clearErrors} = useForm({
        defaultValues:{
            role_name: editRecord ? editRecord.role_name : '',
            permissions: []
        }
    });
    const { fields:permissionsField, append, remove} = useFieldArray({
        control,
        name: 'permissions',
    });

    useEffect(()=>{
        if(permissions && permissions.length){
            permissions.map((item)=>{
                let find = editRecord ? editRecord.permissions.find(row=>row === item.name) : null
                if(find)
                    setAllSelect(true)
                append({name:item.name, status: find ? true : false})
            })
        }
    }, [permissions])

    useEffect(()=>{
        setInterval(()=>{
            clearErrors()
        }, 3000)
    }, [errors])

    const queryClient = useQueryClient();
    const [toastId, setToastId] = useState(null);

    const {isPending, mutate} = useMutation({
        mutationFn: editRecord ? (data) => updateRole(editRecord.id, data) : storeRole,
        onMutate: () => {
            setToastId(toast.loading("Please wait..."))
        },
        onSuccess: (res) => {
            toast.update(toastId, { render: `Role ${editRecord ? 'Updated' : 'Added'}`, type: "success", isLoading: false, autoClose: true });
            queryClient.invalidateQueries({
                predicate: (query) => query.queryKey[0] === 'roles',
            });
            setOpenModal(false)
            setEditUser(null)
            reset();

        },
        onError: (error) => {
            let errorMsg = "Something happened!";
            if (error && error.message && error.message.errors) {
                setValidationMessage(error.message.errors, setError);
                errorMsg = error.message.message;
            }

            toast.update(toastId, { render: errorMsg, type: "error", isLoading: false, autoClose: true });
        }
    });

    const onSubmit = (data) => {
        let permissionData = data.permissions.filter((item)=>item.status === true).map((item)=>{return item.name})
        data.permissions = permissionData
        mutate(data)
    }

    const allSelectUnselect = (status)=>{
        setAllSelect(status)
        if(permissions && permissions.length){
            permissionsField.forEach((field, index) => {
                setValue(`permissions.${index}.status`, status);
            });
        }
    }

    return(
        <>
            <Modal title={`${editRecord ? 'Edit' : 'Add'} Role`} open={openModal} setOpen={setOpenModal}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col_12">
                            <Input label="Name"
                                   name="role_name"
                                   errors={errors}
                                   validationRules={{required: true, type: 'string'}}
                                   register={register}/>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col_12">
                            <div className="width_full d_flex_btwn">
                                <div>
                                    <label className={'required mb_10'}>Permissions</label>
                                    {getErrorObj(errors, 'permissions') && <small className={'color_danger ml_10'}>{getValidationMessage(getErrorObj(errors, 'permissions'), 'label')}</small>}
                                </div>
                            <div>
                                <span onClick={()=>allSelectUnselect(!allSelect)} className={'cursor_pointer text_underline'}>{allSelect? "Unselect all" : 'Select all'}</span>
                            </div>
                            </div>
                            <div className="permission_wrapper   d_inline_flex">
                            {getValues('permissions') && getValues('permissions').map((item, i)=> (
                                <Checkbox name={`permissions[${i}].status`}
                                          key={`role_${i}`}
                                          label={`${item.name}`}
                                          classes="mb_0 width_200p mt_5"
                                          register={register}
                                          checked={getValues(`permissions[${i}].status`) ? 1 : 0}/>
                            ))}
                            </div>
                        </div>

                    </div>


                    <div className="d_flex_end">
                        <Button
                            text="save"
                            isPending={isPending}
                            type={"submit"}
                        />
                    </div>
                </form>
            </Modal>
        </>
    )
}

export default RoleForm